/**
 * Keep in sync with apps/processing-endpoints `MESSAGE_ATTACHMENT_UPLOAD_IDS`
 * (`src/constants/message-context-names.ts`).
 */
export const MESSAGE_ATTACHMENT_UPLOAD_IDS = 'messageAttachmentUploadIds';
